const emptyStringToNull = (value) => value === "" ? null : value;

const nullableInteger = (value) => {
    if (value === "" || value === null || value === undefined || Number.isNaN(value)) {
        return null;
    }

    const parsedValue = Number(value);
    return Number.isInteger(parsedValue) ? parsedValue : value;
};

const nullableBoolean = (value) => {
    if (value === "" || value === null || value === undefined) {
        return null;
    }

    if (typeof value === "boolean") {
        return value;
    }

    if (value === "yes") {
        return true;
    }

    if (value === "no") {
        return false;
    }

    return value;
};

const normalizeAreaToCheck = (area) => {
    const payloadArea = { ...area };
    delete payloadArea.areaToCheckText;

    return {
        ...payloadArea,
        substantiated: emptyStringToNull(payloadArea.substantiated),
        unfounded: emptyStringToNull(payloadArea.unfounded),
        estimatedImplDate: emptyStringToNull(payloadArea.estimatedImplDate),
        actualImplDate: emptyStringToNull(payloadArea.actualImplDate)
    };
};

export const normalizeIncidentInitialPayload = (payload) => ({
    ...payload,
    reportingPerson: emptyStringToNull(payload.reportingPerson),
    repStaff: nullableInteger(payload.repStaff),
    incidentLocation: emptyStringToNull(payload.incidentLocation),
    incidentState: nullableInteger(payload.incidentState),
    dateReportCompleted: emptyStringToNull(payload.dateReportCompleted),
    dateTimeReportReceived: emptyStringToNull(payload.dateTimeReportReceived),
    notifications: (payload.notifications ?? []).map((notification) => ({
        ...notification,
        reportTime: emptyStringToNull(notification.reportTime),
        rptDate: emptyStringToNull(notification.rptDate)
    }))
});

export const normalizeIncidentFollowupPayload = (payload, incidentId) => ({
    ...payload,
    id: incidentId,
    rightsRestrictions: nullableBoolean(payload.rightsRestrictions),
    behaviorSupportPlan: nullableBoolean(payload.behaviorSupportPlan),
    crisisPlan: nullableBoolean(payload.crisisPlan),
    howManyTimes_Individual: nullableInteger(payload.howManyTimes_Individual),
    howManyTimes_Agency: nullableInteger(payload.howManyTimes_Agency),
    dateIncidentFollowupReportCompleted: emptyStringToNull(
        payload.dateIncidentFollowupReportCompleted
    ),
    initialFollowupMissingAndMFPStaffWillRespond: nullableBoolean(
        payload.initialFollowupMissingAndMFPStaffWillRespond
    )
});

export const normalizeIncidentFollowupStaffPayload = (payload, incidentId) => ({
    ...payload,
    id: incidentId,
    staffAssignment: nullableInteger(payload.staffAssignment),
    incidentResponseDueDate: emptyStringToNull(payload.incidentResponseDueDate),
    fieldStaffResponseDate: emptyStringToNull(payload.fieldStaffResponseDate),
    areasToCheck: (payload.areasToCheck ?? []).map(normalizeAreaToCheck)
});

export const normalizeIncidentResponsePayload = (payload, incidentId) => ({
    ...payload,
    id: incidentId,
    responses: (payload.responses ?? []).map((response) => ({
        ...response,
        whoCompletedTheAnalysis: nullableInteger(response.whoCompletedTheAnalysis)
    })),
    areasToCheck: (payload.areasToCheck ?? []).map(normalizeAreaToCheck)
});
